import React, {
  useEffect,
  useState,
} from 'react';
import {
  Card,
  Row,
  Col,
} from 'antd';

// import { transferSettingsActions } from 'store/actions';
import { useLocation } from 'react-router-dom';
import getCountryPhoneCode from 'utils/getCountryPhoneCode';

import Loading from 'components/Loading';
import { SpButton, SpH5, SpText } from 'components/DesignKit';

import RBAC from 'components/rbac';
import { ROLES, COUNTRIES } from 'appconstants';
import Add from '../Add';
import View from '../View';
import Edit from '../Edit';

type Props = {
  fetchTransferSetting: Function,
  updateTransferSetting: Function,
  addTransferSetting: Function,
  transferSettings: Object,
  loading: boolean,
  test: boolean,
  selectedAccount: Object,
  validator: boolean,
};

const TransferSettingsComp = (props: Props) => {
  const location = useLocation();
  const {
    selectedAccount,
    transferSettings,
    loading,
    test,
    fetchTransferSetting,
    updateTransferSetting,
    addTransferSetting,
    validator,
  } = props;
  const { prefix } = selectedAccount && selectedAccount.currency;
  const isIndia = (selectedAccount && selectedAccount.country.id) === COUNTRIES.INDIA.id;
  const [editSettings, setEditSettings] = useState(false);
  const [phoneCode, setPhoneCode] = useState('');

  const getData = () => {
    fetchTransferSetting(location.search);
  };

  useEffect(() => {
    getData();
    if (selectedAccount && selectedAccount.country) {
      setPhoneCode(getCountryPhoneCode(selectedAccount.country.id));
    }
  }, [location, test]);

  useEffect(() => {
    if (selectedAccount && selectedAccount.country) {
      setPhoneCode(getCountryPhoneCode(selectedAccount.country.id));
    }
  }, [selectedAccount]);

  useEffect(() => {
    if (!validator) {
      setEditSettings(false);
    }
  }, [validator]);

  const updateSetting = (record: Object) => {
    const gid = transferSettings && transferSettings.gid;
    const {
      email,
      minLimt,
      maxLimt,
      approveLimt,
      defaultTransferTypeCode,
      enableSmartRouting,
      showActiveInvoice,
      allowManualACH,
      allowUnverified,
      enableApprovals,
    } = record;

    const payloadApproveLimt = approveLimt ? approveLimt.replace(/[^\d]/g, '') : '';
    const payloadMinLimt = minLimt ? minLimt.replace(/[^\d]/g, '') : '';
    const payloadMaxLimt = maxLimt ? maxLimt.replace(/[^\d]/g, '') : '';

    const params = {
      approvalEmail: email,
      minLimit: payloadMinLimt ? Number(payloadMinLimt) : null,
      maxLimit: payloadMaxLimt ? Number(payloadMaxLimt) : null,
      minApprovalLimit: payloadApproveLimt ? Number(payloadApproveLimt) : null,
      defaultTransferTypeCode,
      enableSmartRouting,
      showActiveInvoice,
      allowManualACH,
      allowUnverifiedContact: allowUnverified,
      enableApprovals,
    };

    updateTransferSetting({
      gid,
      params,
    });
  };

  const addSetting = (record: Object) => {
    const {
      email,
      minLimt,
      maxLimt,
      approveLimt,
    } = record;

    const payloadApproveLimt = approveLimt ? approveLimt.replace(/[^\d]/g, '') : '';
    const payloadMinLimt = minLimt ? minLimt.replace(/[^\d]/g, '') : '';
    const payloadMaxLimt = maxLimt ? maxLimt.replace(/[^\d]/g, '') : '';

    addTransferSetting({
      approvalEmail: email,
      minLimit: payloadMinLimt ? Number(payloadMinLimt) : null,
      maxLimit: payloadMaxLimt ? Number(payloadMaxLimt) : null,
      minApprovalLimit: payloadApproveLimt ? Number(payloadApproveLimt) : null,
    });
  };

  const LoadComponent = () => {
    if (Boolean(transferSettings && Object.keys(transferSettings).length) && !editSettings) {
      return (
        <>
          <Row type="flex" justify="space-between" className="my-2 mb-3">
            <Col>
              <SpText className="text-uppercase" fontSize="20px">Manage Transfer</SpText>
            </Col>
            <Col>
              {!editSettings && (
                <RBAC permit={[
                  ROLES.OWNER,
                  ROLES.ADMINISTRATOR,
                  ROLES.SUPERUSER,
                  ROLES.DEVELOPER,
                  ROLES.OPERATIONS,
                  ROLES.OFFICEMANAGER,
                  ROLES.TRANSFERSUPPORT,
                ]}
                >
                  <SpButton
                    type="secondary"
                    shape="round"
                    ghost
                    onClick={() => setEditSettings(true)}
                  >
                    Edit Settings
                  </SpButton>
                </RBAC>
              )}
            </Col>
          </Row>
          <View
            transferSettings={transferSettings}
            selectedAccount={selectedAccount}
          />
        </>
      );
    }
    return editSettings ? (
      <Edit
        transferSettings={transferSettings}
        phoneCode={phoneCode}
        isIndia={isIndia}
        prefix={prefix}
        updateSetting={updateSetting}
        setEditSettings={() => setEditSettings(false)}
        transferTypes={selectedAccount?.supportedTransferTypes ? selectedAccount?.supportedTransferTypes : []}
      />
    ) : (
      <RBAC
        permit={[
          ROLES.OWNER,
          ROLES.ADMINISTRATOR,
          ROLES.SUPERUSER,
          ROLES.DEVELOPER,
          ROLES.OPERATIONS,
          ROLES.OFFICEMANAGER,
          // ROLES.TRANSFERAPPROVER,
          // ROLES.TRANSFERRECON,
          // ROLES.TRANSFERSUPPORT,
        ]}
        fallback={(
          <div
            style={{
              border: '1px solid #CBCBCB',
              minHeight: '253px',
              width: '1014 px',
              marginTop: '10px',
              marginBottom: '25px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '15px',
            }}
          >
            <SpH5 color="#333333">
              Sorry you don&apos;t have permission to access this page
            </SpH5>
          </div>
        )}
      >
        <Add
          status={selectedAccount.status}
          isIndia={isIndia}
          prefix={prefix}
          addSetting={addSetting}
        />
      </RBAC>
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Card className="mb-2">
      <LoadComponent />
    </Card>
  );
};

export default TransferSettingsComp;
